import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import { withCompass } from "../../components/compass/withCompass";
const SearchContinuousBrowsingPage = withCompass(
  () => import("../../pages/SearchContinuousBrowsingPage")
);

export function AmyJinRoutes() {
  return (
    <Switch>
      <Route
        path="/aj/search-continuous-browsing"
        component={SearchContinuousBrowsingPage}
      />
    </Switch>
  );
}

export const slug = "aj";
